export const biddingApi = {
    // 初始化信息
    list: {
        method: 'post',
        api: 'admin/bidding/list'
    },
    add: {
        method: 'post',
        api: 'admin/bidding/add'
    },
    changeStatus: {
        method: 'post',
        api: 'admin/bidding/change_status'
    },
    del: {
        method: 'post',
        api: 'admin/bidding/del'
    },
    getNowBidding: {
        method: 'post',
        api: 'admin/bidding/get_now_bidding'
    },
  }
  